/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { XHR } from './XHR'
import { ListOfIds } from '../model/ListOfIds'
import { PaginatedListTarification } from '../model/PaginatedListTarification'
import { Tarification } from '../model/Tarification'
import { AuthenticationProvider, NoAuthenticationProvider } from '../../icc-x-api/auth/AuthenticationProvider'
import { iccRestApiPath } from './IccRestApiPath'
import {AbstractFilterPricing} from "../model/AbstractFilterPricing"
import { TimingInfo } from '../model/TimingInfo'

export class IccTarificationApi {
  host: string
  headers: Array<XHR.Header>
  authenticationProvider: AuthenticationProvider
  fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>

  constructor(
    host: string,
    headers: any,
    authenticationProvider?: AuthenticationProvider,
    fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>
  ) {
    this.host = iccRestApiPath(host)
    this.headers = Object.keys(headers).map((k) => new XHR.Header(k, headers[k]))
    this.authenticationProvider = !!authenticationProvider ? authenticationProvider : new NoAuthenticationProvider()
    this.fetchImpl = fetchImpl
  }

  setHeaders(h: Array<XHR.Header>) {
    this.headers = h
  }

  handleError(e: XHR.XHRError): never {
    throw e
  }

  /**
   * Type, Tarification and Version are required.
   * @summary Create a Tarification
   * @param body
   */
  async createTarification(body?: Tarification): Promise<Tarification> {
    const _url = this.host + `/tarification` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new Tarification(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns a list of tarifications matched with given input.
   * @summary Finding tarifications by tarification, type and version with pagination.
   * @param region
   * @param type
   * @param tarification
   * @param version
   * @param startDocumentId A tarification document ID
   * @param startKey
   * @param limit Number of rows
   */
  findPaginatedTarifications(
    region?: string,
    type?: string,
    tarification?: string,
    version?: string,
    startDocumentId?: string,
    startKey?: string,
    limit?: number
  ): Promise<PaginatedListTarification> {
    let _body = null

    const _url =
      this.host +
      `/tarification` +
      '?ts=' +
      new Date().getTime() +
      (region ? '&region=' + encodeURIComponent(String(region)) : '') +
      (type ? '&type=' + encodeURIComponent(String(type)) : '') +
      (tarification ? '&tarification=' + encodeURIComponent(String(tarification)) : '') +
      (version ? '&version=' + encodeURIComponent(String(version)) : '') +
      (startDocumentId ? '&startDocumentId=' + encodeURIComponent(String(startDocumentId)) : '') +
      (startKey ? '&startKey=' + encodeURIComponent(String(startKey)) : '') +
      (limit ? '&limit=' + encodeURIComponent(String(limit)) : '')
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new PaginatedListTarification(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns a list of tarifications matched with given input.
   * @summary Finding tarifications by tarification, type and version with pagination.
   * @param region
   * @param types
   * @param language
   * @param label
   * @param startKey
   * @param startDocumentId A tarification document ID
   * @param limit Number of rows
   */
  findPaginatedTarificationsByLabel(
    region?: string,
    types?: string,
    language?: string,
    label?: string,
    startKey?: string,
    startDocumentId?: string,
    limit?: number
  ): Promise<PaginatedListTarification> {
    let _body = null

    const _url =
      this.host +
      `/tarification/byLabel` +
      '?ts=' +
      new Date().getTime() +
      (region ? '&region=' + encodeURIComponent(String(region)) : '') +
      (types ? '&types=' + encodeURIComponent(String(types)) : '') +
      (language ? '&language=' + encodeURIComponent(String(language)) : '') +
      (label ? '&label=' + encodeURIComponent(String(label)) : '') +
      (startKey ? '&startKey=' + encodeURIComponent(String(startKey)) : '') +
      (startDocumentId ? '&startDocumentId=' + encodeURIComponent(String(startDocumentId)) : '') +
      (limit ? '&limit=' + encodeURIComponent(String(limit)) : '')
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new PaginatedListTarification(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * @deprecated Replace with `findPaginatedTarifications` (same but paginated)
   */
  findTarifications(region?: string, type?: string, tarification?: string, version?: string): Promise<Array<Tarification>> {
    let _body = null

    const _url =
      this.host +
      `/tarification/byRegionTypeTarification` +
      '?ts=' +
      new Date().getTime() +
      (region ? '&region=' + encodeURIComponent(String(region)) : '') +
      (type ? '&type=' + encodeURIComponent(String(type)) : '') +
      (tarification ? '&tarification=' + encodeURIComponent(String(tarification)) : '') +
      (version ? '&version=' + encodeURIComponent(String(version)) : '')
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new Tarification(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Get a tarification based on ID or (tarification,type,version) as query strings. (tarification,type,version) is unique.
   * @summary Get a tarification
   * @param tarificationId Tarification id
   */
  getTarification(tarificationId: string): Promise<Tarification> {
    let _body = null

    const _url = this.host + `/tarification/${encodeURIComponent(String(tarificationId))}` + '?ts=' + new Date().getTime()
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new Tarification(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * Get a tarification based on ID or (tarification,type,version) as query strings. (tarification,type,version) is unique.
   * @summary Get a tarification
   * @param type Tarification type
   * @param tarification Tarification tarification
   * @param version Tarification version
   */
  getTarificationWithParts(type: string, tarification: string, version: string): Promise<Tarification> {
    let _body = null

    const _url =
      this.host +
      `/tarification/${encodeURIComponent(String(type))}/${encodeURIComponent(String(tarification))}/${encodeURIComponent(String(version))}` +
      '?ts=' +
      new Date().getTime()
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new Tarification(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * Keys must be delimited by coma
   * @summary Get a list of tarifications by ids
   * @param body
   */
  getTarifications(body?: ListOfIds): Promise<Array<Tarification>> {
    let _body = null
    _body = body

    const _url = this.host + `/tarification/byIds` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new Tarification(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Modification of (type, tarification, version) is not allowed.
   * @summary Modify a tarification
   * @param body
   */
  modifyTarification(body?: Tarification): Promise<Tarification> {
    let _body = null
    _body = body

    const _url = this.host + `/tarification` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new Tarification(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  modifyTarificationsInGroup(groupId: string, tarifications?: Array<Tarification>): Promise<Array<Tarification>> {
    let _body = null
    _body = tarifications

    const _url = this.host + `/tarification/inGroup/${encodeURIComponent(String(groupId))}/batch` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new Tarification(it)))
      .catch((err) => this.handleError(err))
  }

  createTarificationsInGroup(groupId: string, tarifications?: Array<Tarification>): Promise<Array<Tarification>> {
    let _body = null
    _body = tarifications

    const _url = this.host + `/tarification/inGroup/${encodeURIComponent(String(groupId))}/batch` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new Tarification(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Get a list of tarifications by ids/keys.
   * @summary Gets a list of tarifications by ids
   * @param tarificationIds
   */
  async getTarificationsInGroup(groupId: string, tarificationIds: string[]): Promise<Array<Tarification>> {
    const body = new ListOfIds({ ids: tarificationIds })

    const _url = this.host + `/tarification/inGroup/${encodeURIComponent(String(groupId))}/byIds` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new Tarification(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Get ids of tarification matching the provided filter for the current user (HcParty)
   * @param body
   * @param collectTiming if true, include server-side filter timing information in the response
   */
  matchTarificationsByInGroup(groupId: string, body?: AbstractFilterPricing, collectTiming?: false): Promise<Array<string>>
  matchTarificationsByInGroup(groupId: string, body?: AbstractFilterPricing, collectTiming?: true): Promise<Array<string> & TimingInfo>
  async matchTarificationsByInGroup(groupId: string, body?: AbstractFilterPricing, collectTiming: boolean = false): Promise<Array<string>> {
    let _body = null
    _body = body

    const _url = this.host + `/tarification/inGroup/${encodeURIComponent(String(groupId))}/match` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService(), undefined, false, collectTiming ? ['x-filter-timing-*'] : [])
      .then((doc) => Object.assign((doc.body as Array<JSON>).map((it) => JSON.parse(JSON.stringify(it))), collectTiming ? { responseHeaders: doc.responseHeaders } : {}))
      .catch((err) => this.handleError(err))
  }
}
